// @flow
import type {
  AccountOperator,
} from '../types'

// Constants
import { MODEL } from 'hfty-model-accounts'

// Libs
import composeOperator from 'fc-operations'

// Exports
export default function getAccountOperator (): AccountOperator {
  return composeOperator({
    model: MODEL,
    branch: 'accountOperation',
  })
}
